module.exports = __webpack_public_path__ + "static/media/eop.36c8f660.svg";